var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('span',{staticClass:"promotion-content"},[_vm._v("Advertise with us")]),_c('router-link',{staticClass:"contact",attrs:{"tag":"span","to":"/contact"}},[_vm._v("Contact")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }